import {
    FETCH_DRIVERS_REQUEST,
    FETCH_DRIVERS_SUCCESS,
    FETCH_DRIVERS_FAILURE,
    UPDATE_DRIVER_STATUS_REQUEST,
    UPDATE_DRIVER_STATUS_SUCCESS,
    UPDATE_DRIVER_STATUS_FAILURE,
  } from "./types";
  
  import { fetchAllDrivers, updateDriverStatus } from "../../services/driverService";
  
  // Action Creators
  export const fetchDriversRequest = () => ({ type: FETCH_DRIVERS_REQUEST });
  
  export const fetchDriversSuccess = (driversData) => ({
    type: FETCH_DRIVERS_SUCCESS,
    payload: driversData,
  });
  
  export const fetchDriversFailure = (error) => ({
    type: FETCH_DRIVERS_FAILURE,
    payload: error,
  });
  
  // Action Creators for updating driver status
  export const updateDriverStatusRequest = () => ({
    type: UPDATE_DRIVER_STATUS_REQUEST,
  });
  
  export const updateDriverStatusSuccess = (updatedDriver) => ({
    type: UPDATE_DRIVER_STATUS_SUCCESS,
    payload: updatedDriver,
  });
  
  export const updateDriverStatusFailure = (error) => ({
    type: UPDATE_DRIVER_STATUS_FAILURE,
    payload: error,
  });
  
  // Thunk to fetch all drivers
export const fetchDriversAction =
    (
        page = 1,
        size = 20,
        filterField = "status",
        filterValue = ""
    ) =>
    async (dispatch) => {

        dispatch(fetchDriversRequest());

        try {
            const response =
                await fetchAllDrivers(
                    page,
                    size,
                    filterField,
                    filterValue
                );

            if (response.error) {
                dispatch(
                    fetchDriversFailure(
                        response.error
                    )
                );

                return {
                    success: false,
                    error: response.error,
                };
            }

            dispatch(
                fetchDriversSuccess(
                    response.data
                )
            );

            return {
                success: true,
                data: response.data,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to fetch Drivers";

            dispatch(
                fetchDriversFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };
        }
    };
  
// Thunk to update Driver status with optional statusReason
export const updateDriverStatusAction = (driverId, newStatus, statusReason = null) => async (dispatch) => {
  dispatch(updateDriverStatusRequest());

  try {
    const response = await updateDriverStatus(driverId, newStatus, statusReason);

    if (response.success) {
      dispatch(updateDriverStatusSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      dispatch(updateDriverStatusFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to update driver status";
    console.error("updateDriverStatusAction error:", errMsg);
    dispatch(updateDriverStatusFailure(errMsg));
    return { success: false, error: errMsg };
  }
};

